/**
 * Media Gallery Toggle
 * Handles show more/less functionality for product image galleries
 * Uses direct DOM manipulation for reliable show/hide
 */

(function() {
  'use strict';

  function initGalleryToggle() {
    const buttons = document.querySelectorAll('.show-more-images-btn');
    
    buttons.forEach(button => {
      // Skip if already initialized
      if (button.dataset.initialized === 'true') return;
      button.dataset.initialized = 'true';
      
      const wrapper = button.closest('.media-gallery-wrapper');
      const gallery = wrapper?.querySelector('.media-gallery-grid');
      
      if (!wrapper || !gallery) {
        console.warn('Media gallery toggle: wrapper or gallery not found');
        return;
      }
      
      const showMoreText = button.querySelector('.show-more-text');
      const showLessText = button.querySelector('.show-less-text');
      
      // Get all direct children of the gallery (the image elements)
      const allImages = Array.from(gallery.children);
      const imagesToToggle = allImages.slice(5); // Images from index 5 onwards (6th, 7th, etc.)
      
      // Initially hide images beyond the 5th
      imagesToToggle.forEach(img => {
        img.style.display = 'none';
      });
      
      let isExpanded = false;
      
      button.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        isExpanded = !isExpanded;
        
        if (isExpanded) {
          // Show all hidden images
          imagesToToggle.forEach(img => {
            img.style.display = '';
          });
          
          // Add expanded class to wrapper - CSS will handle text visibility
          wrapper.classList.add('expanded');
          
          // Remove hidden class from show-less-text to ensure it's visible
          if (showLessText) showLessText.classList.remove('hidden');
          if (showMoreText) showMoreText.classList.add('hidden');
        } else {
          // Hide images beyond 5th
          imagesToToggle.forEach(img => {
            img.style.display = 'none';
          });
          
          // Remove expanded class from wrapper - CSS will handle text visibility
          wrapper.classList.remove('expanded');
          
          // Add hidden class back to show-less-text
          if (showLessText) showLessText.classList.add('hidden');
          if (showMoreText) showMoreText.classList.remove('hidden');
          
          // Scroll back to top of gallery
          gallery.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      });
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGalleryToggle);
  } else {
    initGalleryToggle();
  }

  // Also handle dynamic content (e.g., AJAX-loaded products)
  const observer = new MutationObserver(() => {
    initGalleryToggle();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();
